import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { DocumentService } from '@app/shared/services';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'credentials',
  templateUrl: './credentials.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoveryCredentialsComponent implements OnInit, OnDestroy {
  securityStateObject;
  subscription: Subscription = new Subscription();
  @Output() moveNextPreviousEvent = new EventEmitter<any>();
  currentuserId;
  loadOnce = true;
  @Input() data;
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  constructor(
    private documentService: DocumentService,
    private loginService: LoginStoreEffects,
    private store: Store,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.loginService.loginObject.subscribe((state) => {
        if (state?.data) {
          this.currentuserId = state.data.id;
          if (this.loadOnce) {
            this.loadOnce = false;
          }
        }
      })
    );
  }
  parentFun(event) {
    this.moveNextPreviousEvent.next({ event: event.status, id: this.data.id });
  }
}
